import { csx } from '@vtex/admin-ui'
import { DRAWER_ZINDEX } from '../Drawer/drawer.css'

const popoverItemHeight = 2.25

const popoverItemPaddingY = 0.75

export const styles = {
  default: csx({
    width: '100%',
    '*': {
      flexDirection: 'unset',
      overflow: 'hidden',
    },
    p: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
    },
  }),
  disabled: csx({
    pointerEvents: 'none',
    background: '$disabled',
    input: {
      background: '$disabled',
    },
  }),
  error: csx({
    ':hover': {
      border: '$form.criticalHover',
    },
    border: '$form.critical',
  }),
  popover: csx({
    maxHeight: `${popoverItemHeight * 10 + popoverItemPaddingY * 2}rem`,
    overflowY: 'auto',
    zIndex: DRAWER_ZINDEX + 2,
    '[data-disabled="true"]': {
      pointerEvents: 'none',
      svg: {
        display: 'none',
      },
      '*': {
        '&&': {
          background: '$primary',
        },
      },
    },
  }),
}
